import Vue from "vue";
import Vuex from "vuex";
// import * as actions from "./actions";
// import * as mutations from "./mutations";
import modules from "./modules";
import pc from "./modules/pc";
import getters from "./getters";

Vue.use(Vuex);
const debug = process.env.NODE_ENV !== "production";

export default new Vuex.Store({
  modules,
  getters,
  ...pc,
  strict: debug
});
